<template>
  <section class="imageteaser">
    <div class="imageteaser-image">
      <slot name="image" />
    </div>
    <div  class="imageteaser-container">
      <div :class="{'imageteaser-box': true, 'hidden': footerContactFormIsVisible}">
        <slot />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({props: {footerContactFormIsVisible: {default: false}} });
</script>

<style lang="scss" scoped>
$color-secondary-darkblue-transparent: transparentize(
  $color: $color-secondary-darkblue,
  $amount: 0.3,
);
$corner-size: 30px;

.imageteaser {
  position: relative;

  &-container {
    position: relative;
    max-width: $layout-size;
    margin: 0 auto;
    padding-bottom: 40px;

    @include fit(800) {
      display: flex;
      justify-content: flex-end;
      padding: 150px $layout-size-padding 120px;
    }
  }

  &-image {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding-top: 40px;
    @include fit(800) {
      position: absolute;
      z-index: 1;
    }

    img {
      display: block;
      width: 100%;
      max-height: 150px;
      object-fit: cover;
      object-position: center center;

      @include fit(800) {
        max-height: 100%;
        height: 100%;
      }
    }
  }

  &-box {
    color: #fff;
    background: $color-secondary-darkblue-transparent;
    padding: 40px $layout-size-padding;
    position: relative;
    z-index: 2;

    &.hidden {
      visibility: hidden;
    }

    @include fit(800) {
      background: linear-gradient(
        135deg,
        transparent $corner-size,
        $color-secondary-darkblue-transparent $corner-size
      );
      padding: 30px 40px;
      width: 450px;
    }
  }
}
</style>
